<template>
	<div class="Newest">
		<div class="Newest_title">
			{{ company.company }}
		</div>
		<a-divider></a-divider>
		<a-row>
			<a-col>
				合同周期： {{ company.start_time }} 至 {{ company.end_time }}
				<a-tag color="#87d068">
					{{
            company.status == 'PASSED' ? '审核通过' :
                company.status == 'PENDING' ? '待审核' :
                    company.status == 'REJECT' ? '驳回' : null
          }}
				</a-tag>
			</a-col>
			<a-col>
				负责人：{{ company.name }} {{company.tel}}
			</a-col>
			<a-col>
				审核时间：{{ company.auditor_at }}
			</a-col>
			<a-col>
				审核人：{{ company.auditor_by_name }}
			</a-col>
		</a-row>
		<a-tabs type="card" @change="callback" style="margin-top: 20px">
			<a-tab-pane key="1" tab="订单数据">
				<a-row>
					<a-col>
						订单状态：
						<span @click="get_state(index)" style="cursor: pointer" v-for="(item,index) in btn_state"
							:style="{color:item.click?'#02A7F0':'#333333'}">
							{{ item.text }}
							<span style="color: #D9001B">({{ item.count }})</span>
						</span>
					</a-col>
				</a-row>
				<a-row style="margin-top: 15px">
					<a-col>
						订单阶段：
						<span @click="get_stage(index,item.value)" style="cursor: pointer"
							v-for="(item,index) in btn_stage" :style="{color:item.click?'#02A7F0':'#333333'}">
							{{ item.text }}
							<span style="color: #D9001B">({{ item.count }})</span>
						</span>
					</a-col>
				</a-row>
				<a-row :gutter="30" style="padding-top: 30px">
					<a-col span="8" style="margin-bottom: 25px">
						<a-row type="flex" align="top">
							<a-col span="6" class="form-label">投递时间/推荐时间</a-col>
							<a-col span="18">
								<a-range-picker showTime style="display: block; width: auto" format="YYYY-MM-DD"
									v-model="params.time" />
							</a-col>
						</a-row>
					</a-col>
					<a-col span="8" style="margin-bottom: 25px">
						<a-row type="flex" align="top">
							<a-col span="6" class="form-label">所在城市</a-col>
							<a-col span="18">
								<a-cascader changeOnSelect :options="options" v-model="params.city"
									:fieldNames="{ label: 'name', value: 'id', children: 'children' }"
									placeholder="请选择城市" style="display: block" @click="getOptions">
									<a-icon slot="suffixIcon" :type="options ? 'down' : 'loading'" />
								</a-cascader>
							</a-col>
						</a-row>
					</a-col>
					<a-col span="8" style="margin-bottom: 25px">
						<!-- <a-row type="flex" align="top">
              <a-col span="6" class="form-label">职位名称</a-col>
              <a-col span="18">
                <a-input style="display:block" placeholder="请输入关键字" v-model="params.job_name"></a-input>
              </a-col>
            </a-row>-->
						<a-input-group compact>
							<a-select v-model="params.jobType" style="width: 35%">
								<a-select-option value="job_id">职位ID</a-select-option>
								<a-select-option value="job_name">职位名称</a-select-option>
							</a-select>
							<a-input v-model="params.jobValue" style="width: 65%" placeholder="请输入关键字"></a-input>
						</a-input-group>
					</a-col>
					<a-col span="8" style="margin-bottom: 25px">
						<a-row type="flex" align="top">
							<a-col span="6" class="form-label">公司名称</a-col>
							<a-col span="18">
								<a-input style="display: block" placeholder="请输入关键字" v-model="params.company_name">
								</a-input>
							</a-col>
						</a-row>
					</a-col>
					<a-col span="8" style="margin-bottom: 25px">
						<a-input-group compact>
							<a-select v-model="params.main" style="width: 35%">
								<a-select-option value="user_tel">猎头手机</a-select-option>
								<a-select-option value="user_email">猎头邮箱</a-select-option>
								<a-select-option value="user_name">猎头姓名</a-select-option>
							</a-select>
							<a-input v-model="params.mainValue" style="width: 65%" placeholder="请输入关键字"></a-input>
						</a-input-group>
					</a-col>
					<a-col span="8" style="margin-bottom: 25px">
						<a-input-group compact>
							<a-select v-model="params.resume" style="width: 35%">
								<a-select-option value="resume_mobile">候选人手机</a-select-option>
								<a-select-option value="resume_email">候选人邮箱</a-select-option>
								<a-select-option value="resume_name">候选人姓名</a-select-option>
							</a-select>
							<a-input v-model="params.resumeValue" style="width: 65%" placeholder="请输入关键字"></a-input>
						</a-input-group>
					</a-col>
					<a-col span="8" style="margin-bottom: 25px">
						<a-row type="flex" align="top">
							<a-col span="6" class="form-label">IE</a-col>
							<a-col span="18">
								<a-auto-complete allowClear style="display: block" :dataSource="suggestion"
									@search="handleSearch" v-model="params.ie_user_id" placeholder="请输入关键字">
								</a-auto-complete>
							</a-col>
						</a-row>
					</a-col>
					<a-col span="8" style="margin-bottom: 25px">
						<a-row type="flex" align="top">
							<a-col span="6" class="form-label">订单号</a-col>
							<a-col span="18">
								<a-input style="display: block" placeholder="请输入关键字" v-model="params.order_no">
								</a-input>
							</a-col>
						</a-row>
					</a-col>
					<!-- <a-col span="8" style="margin-bottom:25px;" v-if="params.statuses == 'CREATED,AUDIT_PASSED'">
            <a-row type="flex" align="middle" style="padding-top:5px">
              <a-col span="6" style="text-align:center">订单状态：</a-col>
              <a-col span="18">
                <a-radio-group v-model="params.sub_statuses">
                  <a-radio value="CREATED,AUDIT_PASSED">全部</a-radio>
                  <a-radio value="CREATE">新推荐</a-radio>
                  <a-radio value="AUDIT_PASSED">审核通过</a-radio>
                </a-radio-group>
              </a-col>
            </a-row>
          </a-col>-->
				</a-row>
				<a-row type="flex" justify="space-between">
					<a-col>
						<a-button type="primary" style="margin-right: 12px; padding: 0 30px" @click="getFilterData(1)">
							筛选
						</a-button>
						<a-button style="margin-right: 12px" @click="resetParams(1)">清空筛选条件
						</a-button>
						<span>共找到 {{ pagination.total }} 条信息</span>
					</a-col>
					<!--          <a-col-->
					<!--              v-if="isGranted('post_manager.post_' + order + '_list.btn_export_data')"-->
					<!--          >-->
					<!--            <a-button type="primary">导出数据</a-button>-->
					<!--          </a-col>-->
				</a-row>

				<div class="data-table" style="padding: 30px 0">
					<a-table :columns="columns" :dataSource="dataSource" rowKey="id" :pagination="pagination"
						:loading="loading" @change="getData" :customRow="rowClick">
						<template slot="hunter" slot-scope="name, record">
							<span>{{ name }}</span>
							<span class="badge" v-if="record.is_sign == 1">签</span>
						</template>
						<template slot="status" slot-scope="status, record">
							<span :class="{
              tag: true,
              blue:
                [
                  'HUNTER_REFUSE','DELIVER'
                ].indexOf(status) > -1,
            }" v-if="record.source=='columbus_mini_app'">投</span>
							<span :class="{
              tag: true,
              blue:
                [
                  'CREATED',
                  'AUDIT_PASSED',
                  'AUDIT_FAILED',
                  'SUBMIT_FAILED',
                ].indexOf(status) > -1,
            }">推</span>
							<span :class="{
              tag: true,
              blue:
                [
                  'SUBMIT_PASSED',
                  'INTERVIEW',
                  'INTERVIEW_FAILED',
                  'CLOSED',
                ].indexOf(status) > -1,
            }">面</span>
							<span :class="{ tag: true, blue: ['OFFERED'].indexOf(status) > -1 }">录</span>
							<span :class="{
              tag: true,
              blue: ['ENTERED', 'NOT_ENTERED'].indexOf(status) > -1,
            }">职</span>
							<span :class="{
              tag: true,
              blue:
                ['COMPLETED', 'NOT_COMPLETED', 'UNSETTLED', 'SETTLED'].indexOf(
                  status
                ) > -1,
            }">保</span>
						</template>
						<template slot="action" slot-scope="{ status }, record">
							<div v-if="record.ie_user_id == $store.state.user.uid">
								<a-row type="flex" justify="center" align="middle" v-if="status == 'DELIVER'">
									<a-col>
										<a-button type="link" @click.stop="nextStep('受理并推荐', record)">受理并推荐
										</a-button>
										<br />
										<a-button type="link" @click.stop="stopStep('审核不通过', record)">审核不通过
										</a-button>
									</a-col>
								</a-row>
								<a-row type="flex" justify="center" align="middle" v-if="status == 'CREATED'">
									<a-col>
										<a-button type="link" @click.stop="nextStep('审核通过', record)">审核通过
										</a-button>
										<br />
										<a-button type="link" @click.stop="stopStep('审核不通过', record)">审核不通过
										</a-button>
									</a-col>
									<a-col style="marginright: 15px">
										<a-divider type="vertical" style="margin: 0; height: 15px; background: #00a2eb">
										</a-divider>
									</a-col>
									<a-col>
										<a-dropdown>
											<a @click.prevent.stop>
												更多
												<a-icon type="down"></a-icon>
											</a>
											<a-menu slot="overlay">
												<a-menu-item
													@click="drawer = true;order_id=record.id;communicate.key='7'">回款开票
												</a-menu-item>
												<a-menu-item @click="$refs.addCommunicationModal.show(record)">沟通记录
												</a-menu-item>
												<a-menu-item @click="$refs.commentModal.show(record)">软性点评
												</a-menu-item>
												<a-menu-item @click="$refs.preview.show(record.attachment)">附件简历
												</a-menu-item>
												<a-menu-item>
													<a :href="
                          baseUrl +
                          '/resume/downloadAttachment?attachment_id=' +
                          record.attachment.id +
                          '&token=' +
                          $store.state.token
                        " download>下载简历附件</a>
												</a-menu-item>
												<a-menu-item>
													<a :href="
                          baseUrl +
                          '/post/report/downloadPdfReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        " download>简历报告(PDF)</a>
												</a-menu-item>
												<a-menu-item>
													<a :href="
                          baseUrl +
                          '/post/report/downloadDocReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        " download>简历报告(DOC)</a>
												</a-menu-item>
											</a-menu>
										</a-dropdown>
									</a-col>
								</a-row>
								<a-row type="flex" justify="center" align="middle" v-if="status == 'AUDIT_PASSED'">
									<a-col>
										<a-button type="link" @click.stop="nextStep('推荐通过', record)">推荐通过
										</a-button>
										<br />
										<a-button type="link" @click.stop="stopStep('推荐不通过', record)">推荐不通过
										</a-button>
									</a-col>
									<a-col style="marginright: 15px">
										<a-divider type="vertical" style="margin: 0; height: 15px; background: #00a2eb">
										</a-divider>
									</a-col>
									<a-col>
										<a-dropdown>
											<a @click.prevent.stop>
												更多
												<a-icon type="down"></a-icon>
											</a>
											<a-menu slot="overlay">
												<a-menu-item @click="$refs.addCommunicationModal.show(record)">沟通记录
												</a-menu-item>
												<a-menu-item @click="$refs.commentModal.show(record)">软性点评
												</a-menu-item>
												<a-menu-item @click="$refs.preview.show(record.attachment)">附件简历
												</a-menu-item>
												<a-menu-item>
													<a :href="
                          baseUrl +
                          '/resume/downloadAttachment?attachment_id=' +
                          record.attachment.id +
                          '&token=' +
                          $store.state.token
                        " download>下载简历附件</a>
												</a-menu-item>
												<a-menu-item>
													<a :href="
                          baseUrl +
                          '/post/report/downloadPdfReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        " download>简历报告(PDF)</a>
												</a-menu-item>
												<a-menu-item>
													<a :href="
                          baseUrl +
                          '/post/report/downloadDocReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        " download>简历报告(DOC)</a>
												</a-menu-item>
											</a-menu>
										</a-dropdown>
									</a-col>
								</a-row>
								<a-row type="flex" justify="center" align="middle" v-if="status == 'SUBMIT_PASSED'">
									<a-col>
										<a-button type="link" @click.stop="$refs.arrangeInterviewModal.show(record)">
											安排面试
										</a-button>
										<br />
									</a-col>
									<a-col style="marginright: 15px">
										<a-divider type="vertical" style="margin: 0; height: 15px; background: #00a2eb">
										</a-divider>
									</a-col>
									<a-col>
										<a-dropdown>
											<a @click.prevent.stop>
												更多
												<a-icon type="down"></a-icon>
											</a>
											<a-menu slot="overlay">
												<a-menu-item @click="$refs.addCommunicationModal.show(record)">沟通记录
												</a-menu-item>
												<a-menu-item @click="$refs.commentModal.show(record)">软性点评
												</a-menu-item>
												<a-menu-item @click="$refs.preview.show(record.attachment)">附件简历
												</a-menu-item>
												<a-menu-item>
													<a :href="
                          baseUrl +
                          '/resume/downloadAttachment?attachment_id=' +
                          record.attachment.id +
                          '&token=' +
                          $store.state.token
                        " download>下载简历附件</a>
												</a-menu-item>
												<a-menu-item>
													<a :href="
                          baseUrl +
                          '/post/report/downloadPdfReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        " download>简历报告(PDF)</a>
												</a-menu-item>
												<a-menu-item>
													<a :href="
                          baseUrl +
                          '/post/report/downloadDocReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        " download>简历报告(DOC)</a>
												</a-menu-item>
												<a-menu-item @click="stopStep('关闭订单', record)">关闭订单
												</a-menu-item>
											</a-menu>
										</a-dropdown>
									</a-col>
								</a-row>
								<a-row type="flex" justify="center" align="middle" v-if="status == 'INTERVIEW'">
									<a-col v-if="
                  record.interviews.length > 0 &&
                  record.interviews[0].status === 'PROCESS'
                ">
										<a-button type="link" @click.stop="$refs.checkInterviewModal.show(record)">
											标记面试结果
										</a-button>
										<br />
										<a-button type="link" @click.stop="$refs.cancelInterviewModal.show(record)">取消面试
										</a-button>
									</a-col>
									<a-col v-else>
										<a-button type="link" @click.stop="$refs.arrangeInterviewModal.show(record)">
											安排下一轮面试
										</a-button>
										<br />
										<a-button type="link" @click.stop="$refs.offerModal.show(record)">发送offer
										</a-button>
									</a-col>
									<a-col style="marginright: 15px">
										<a-divider type="vertical" style="margin: 0; height: 15px; background: #00a2eb">
										</a-divider>
									</a-col>
									<a-col>
										<a-dropdown>
											<a @click.prevent.stop>
												更多
												<a-icon type="down"></a-icon>
											</a>
											<a-menu slot="overlay">
												<a-menu-item @click="$refs.addCommunicationModal.show(record)">沟通记录
												</a-menu-item>
												<a-menu-item @click="$refs.commentModal.show(record)">软性点评
												</a-menu-item>
												<a-menu-item @click="$refs.preview.show(record.attachment)">附件简历
												</a-menu-item>
												<a-menu-item>
													<a :href="
                          baseUrl +
                          '/resume/downloadAttachment?attachment_id=' +
                          record.attachment.id +
                          '&token=' +
                          $store.state.token
                        " download>下载简历附件</a>
												</a-menu-item>
												<a-menu-item>
													<a :href="
                          baseUrl +
                          '/post/report/downloadPdfReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        " download>简历报告(PDF)</a>
												</a-menu-item>
												<a-menu-item>
													<a :href="
                          baseUrl +
                          '/post/report/downloadDocReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        " download>简历报告(DOC)</a>
												</a-menu-item>
												<!-- <a-menu-item
                          v-if="
                            record.interviews.length == 1 &&
                              record.interviews[0].status === 'PROCESS'
                          "
                          @click="stopStep('关闭订单', record)"
                        >关闭订单</a-menu-item>-->
												<a-menu-item @click="stopStep('关闭订单', record)">关闭订单
												</a-menu-item>
											</a-menu>
										</a-dropdown>
									</a-col>
								</a-row>
								<a-row type="flex" justify="center" align="middle" v-if="status == 'OFFERED'">
									<a-col>
										<a-button type="link" @click.stop="nextStep('已入职', record)">已入职
										</a-button>
										<br />
										<a-button type="link" @click.stop="stopStep('未入职', record)">未入职
										</a-button>
									</a-col>
									<a-col style="marginright: 15px">
										<a-divider type="vertical" style="margin: 0; height: 15px; background: #00a2eb">
										</a-divider>
									</a-col>
									<a-col>
										<a-dropdown>
											<a @click.prevent.stop>
												更多
												<a-icon type="down"></a-icon>
											</a>
											<a-menu slot="overlay">
												<a-menu-item @click="$refs.addCommunicationModal.show(record)">沟通记录
												</a-menu-item>
												<a-menu-item @click="$refs.commentModal.show(record)">软性点评
												</a-menu-item>
												<a-menu-item @click="$refs.preview.show(record.attachment)">附件简历
												</a-menu-item>
												<a-menu-item>
													<a :href="
                          baseUrl +
                          '/resume/downloadAttachment?attachment_id=' +
                          record.attachment.id +
                          '&token=' +
                          $store.state.token
                        " download>下载简历附件</a>
												</a-menu-item>
												<a-menu-item>
													<a :href="
                          baseUrl +
                          '/post/report/downloadPdfReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        " download>简历报告(PDF)</a>
												</a-menu-item>
												<a-menu-item>
													<a :href="
                          baseUrl +
                          '/post/report/downloadDocReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        " download>简历报告(DOC)</a>
												</a-menu-item>
											</a-menu>
										</a-dropdown>
									</a-col>
								</a-row>
								<a-row type="flex" justify="center" align="middle" v-if="status == 'ENTERED'">
									<a-col>
										<a-button type="link" @click.stop="nextStep('已过保', record)">已过保
										</a-button>
										<br />
										<a-button type="link" @click.stop="stopStep('未过保', record)">未过保
										</a-button>
									</a-col>
									<a-col style="marginright: 15px">
										<a-divider type="vertical" style="margin: 0; height: 15px; background: #00a2eb">
										</a-divider>
									</a-col>
									<a-col>
										<a-dropdown>
											<a @click.prevent.stop>
												更多
												<a-icon type="down"></a-icon>
											</a>
											<a-menu slot="overlay">
												<a-menu-item @click="$refs.addCommunicationModal.show(record)">沟通记录
												</a-menu-item>
												<a-menu-item @click="$refs.commentModal.show(record)">软性点评
												</a-menu-item>
												<a-menu-item @click="$refs.preview.show(record.attachment)">附件简历
												</a-menu-item>
												<a-menu-item>
													<a :href="
                          baseUrl +
                          '/resume/downloadAttachment?attachment_id=' +
                          record.attachment.id +
                          '&token=' +
                          $store.state.token
                        " download>下载简历附件</a>
												</a-menu-item>
												<a-menu-item>
													<a :href="
                          baseUrl +
                          '/post/report/downloadPdfReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        " download>简历报告(PDF)</a>
												</a-menu-item>
												<a-menu-item>
													<a :href="
                          baseUrl +
                          '/post/report/downloadDocReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        " download>简历报告(DOC)</a>
												</a-menu-item>
											</a-menu>
										</a-dropdown>
									</a-col>
								</a-row>
								<a-row type="flex" justify="center" align="middle" v-if="status == 'COMPLETED'">
									<a-col>
										<a-button type="link" @click.stop="nextStep('归档', record)">归档
										</a-button>
									</a-col>
									<a-col style="marginright: 15px">
										<a-divider type="vertical" style="margin: 0; height: 15px; background: #00a2eb">
										</a-divider>
									</a-col>
									<a-col>
										<a-dropdown>
											<a @click.prevent.stop>
												更多
												<a-icon type="down"></a-icon>
											</a>
											<a-menu slot="overlay">
												<a-menu-item @click="$refs.addCommunicationModal.show(record)">沟通记录
												</a-menu-item>
												<a-menu-item @click="$refs.commentModal.show(record)">软性点评
												</a-menu-item>
												<a-menu-item @click="$refs.preview.show(record.attachment)">附件简历
												</a-menu-item>
												<a-menu-item>
													<a :href="
                          baseUrl +
                          '/resume/downloadAttachment?attachment_id=' +
                          record.attachment.id +
                          '&token=' +
                          $store.state.token
                        " download>下载简历附件</a>
												</a-menu-item>
												<a-menu-item>
													<a :href="
                          baseUrl +
                          '/post/report/downloadPdfReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        " download>简历报告(PDF)</a>
												</a-menu-item>
												<a-menu-item>
													<a :href="
                          baseUrl +
                          '/post/report/downloadDocReport?report_id=' +
                          record.resume_report_id +
                          '&token=' +
                          $store.state.token
                        " download>简历报告(DOC)</a>
												</a-menu-item>
											</a-menu>
										</a-dropdown>
									</a-col>
								</a-row>
							</div>
							<div v-else>
								<a-button type="link" @click.stop="$refs.preview.show(record.attachment)">附件简历
								</a-button>
							</div>
						</template>
					</a-table>
				</div>
			</a-tab-pane>
			<a-tab-pane key="2" tab="猎企成员">
				<a-row :gutter="30" style="margin-bottom: 15px">
					<a-col span="8">
						<a-row type="flex" align="top">
							<a-col span="6" class="form-label">猎头姓名</a-col>
							<a-col span="18">
								<a-input style="display: block" placeholder="请输入信息" v-model="params.name"></a-input>
							</a-col>
						</a-row>
					</a-col>
					<a-col span="8">
						<a-button type="primary" style="margin-right: 12px; padding: 0 30px" @click="getFilterData(2)">
							筛选
						</a-button>
						<a-button style="margin-right: 12px" @click="resetParams(2)">重置
						</a-button>
					</a-col>
				</a-row>
				<a-row>
					<a-col span="15">
						<time-bar ref="timeTeam" :clean="clean" @change="onChangetime"></time-bar>
					</a-col>
					<!--          <a-col span="2" style="text-align: center">-->
					<!--            <a-button type="primary">-->
					<!--              导出数据-->
					<!--            </a-button>-->
					<!--          </a-col>-->
				</a-row>
				<a-table style="margin-top: 20px" :pagination="pagination2" :columns="columns2"
					:data-source="dataSource2" rowKey="id" @change="getData">
					<template slot="CREATED" slot-scope="status, record">
						<span>{{ status.post_counts.CREATED ? status.post_counts.CREATED : 0 }}</span>
					</template>
					<template slot="AUDIT_PASSED" slot-scope="status, record">
						<span>{{ status.post_counts.AUDIT_PASSED ? status.post_counts.AUDIT_PASSED : 0 }}</span>
					</template>
					<template slot="INTERVIEW" slot-scope="status, record">
						<span>{{ status.post_counts.INTERVIEW ? status.post_counts.INTERVIEW : 0 }}</span>
					</template>
					<template slot="OFFERED" slot-scope="status, record">
						<span>{{ status.post_counts.OFFERED ? status.post_counts.OFFERED : 0 }}</span>
					</template>
					<template slot="ENTERED" slot-scope="status, record">
						<span>{{ status.post_counts.ENTERED ? status.post_counts.ENTERED : 0 }}</span>
					</template>
					<template slot="COMPLETED" slot-scope="status, record">
						<span>{{ status.post_counts.COMPLETED ? status.post_counts.COMPLETED : 0 }}</span>
					</template>
					<template slot="complete" slot-scope="status, record">
						<span>{{
                (status.post_counts.UNSETTLED && status.post_counts.SETTLED) ? Number(status.post_counts.UNSETTLED) + Number(status.post_counts.SETTLED) : 0
              }}</span>
					</template>
					<template slot="CLOSED" slot-scope="status, record">
						<span>{{
                status.post_counts.CLOSED ? status.post_counts.CLOSED : 0
              }}</span>
					</template>
					<template slot="newest_post" slot-scope="status, record">
						<span>{{
                status.newest_post ? status.newest_post.created_at : 0
              }}</span>
					</template>
				</a-table>
			</a-tab-pane>
			<a-tab-pane key="3" tab="合同信息">
				<a-table :columns="columns3" :dataSource="list" class="hunter-table" :pagination="pagination3"
					:loading="loading3" rowKey="id">
					<span slot="info" slot-scope="text, record">
						合同类型：{{ record.type == "PERSONAL" ? "个人签约" : "猎企签约" }}
						<br />
						合同ID：{{ record.id }} <br />合同甲方：{{ record.parta_person_name }} <br />合同乙方：{{ record.name }}
					</span>
					<span slot="signing_info" slot-scope="text, record">
						合同周期：{{ record.start_time }}-{{ record.end_time }}
						<br />
						佣金比例：{{ Number(record.additional_allowance_ratio) + 50 }} <br />备注：
					</span>
					<span slot="examine" slot-scope="text, record">
						审核时间：{{ record.auditor_at }}
						<br />
						审核人：{{ record.auditor_by_name }}
					</span>
					<span slot="enclosure" slot-scope="text, record">
						<span v-for="(item, i) in record.attachments" :key="i">
							{{
            item.type == "1"
                ? "身份证正面："
                : item.type == "2"
                ? "身份证反面："
                : item.type == "3"
                    ? "电子签章："
                    : "合同附件："
          }}
							<a @click="attachmentsDetail(item.file_url)">{{ item.file_name }}</a>
							<br />
						</span>
					</span>
					<span slot="action" slot-scope="record" class="action">
						<span v-if="record.status === 'PENDING'">
							<a @click="$refs.contractPassModal.show(record.id)">审核通过</a>&nbsp;
							<a href="javascript:;" @click="() => refuse(record.id)">审核不通过</a>&nbsp;
						</span>
						<span v-if="record.status === 'PASSED'">已审核通过</span>
						<span v-if="record.status === 'REJECT'">已拒绝</span>
					</span>
				</a-table>
			</a-tab-pane>
		</a-tabs>
		<a-modal v-model="refusalMadel" title="请编辑理由">
			<template slot="footer">
				<a-button key="back" @click="handleRefuseCancel">取消</a-button>
				<a-button key="submit" type="primary" :loading="loading3" @click="addRefuseModal">确认
				</a-button>
			</template>
			<div>
				<b>编辑审核不通过理由：</b>
			</div>
			<div style="position: relative">
				<a-textarea placeholder="请填写淘汰理由，该条信息将直接反馈给签约用户" :rows="4" maxlength="50" v-model="refusalReasons"
					@change="handleRefusalLength" />
				<span class="count">{{ reasonsLength }} / 50</span>
			</div>
		</a-modal>
		<contract-pass-modal ref="contractPassModal" @ok="getData3()"></contract-pass-modal>
		<a-drawer :visible="drawer" :closable="false" width="1000" @close="drawer = !drawer" :destroyOnClose="true">
			<a-row type="flex" justify="space-between" align="middle" style="paddingbottom: 40px">
				<a-col style="cursor: pointer" @click="drawer = !drawer">
					<icon-font type="guanbi" :style="{ fontSize: '19px' }" />
				</a-col>
				<a-col style="cursor: pointer" @click="viewDetail">
					<a-icon type="fullscreen" />
					在新窗口打开
				</a-col>
			</a-row>
			<order-detail :id="order_id" :communicate="communicate.key"></order-detail>
		</a-drawer>
		<!-- //modal -->
		<failed-modal ref="failedModal" @ok="getData()"></failed-modal>
		<cancel-interview-modal ref="cancelInterviewModal" @ok="getData()"></cancel-interview-modal>
		<check-interview-modal ref="checkInterviewModal" @ok="getData()" @cancel="unpassInterview">
		</check-interview-modal>
		<offer-modal ref="offerModal" @ok="getData()"></offer-modal>
		<add-communication-modal ref="addCommunicationModal"></add-communication-modal>
		<arrange-interview-modal ref="arrangeInterviewModal" @ok="getData()"></arrange-interview-modal>
		<comment-modal ref="commentModal"></comment-modal>
		<resume-preview-modal ref="preview"></resume-preview-modal>
		<a-modal title="添加沟通记录" :confirmLoading="communicate.loading" :destroyOnClose="true"
			v-model="communicate.visible" @ok="handleOk">
			<a-form :form="communicate.form">
				<a-form-item label="沟通记录">
					<a-textarea :rows="6" v-decorator="[
            'content',
            { rules: [{ required: true, message: '请填写沟通记录' }] },
          ]"></a-textarea>
				</a-form-item>
			</a-form>
		</a-modal>
	</div>
</template>

<script>
	import Api from "@/api";
	import {
		getOrderStatus
	} from "@/shared/utils/bootstrap";
	import {
		mapGetters,
		mapState
	} from "vuex";
	import baseComponentVue from "@/components/base-component";
	import FailedModal from "@/app/admin/order/failed-modal";
	import OrderDetail from "@/app/admin/order/order-detail";
	import CancelInterviewModal from "@/app/admin/order/cancel-interview-modal";
	import CheckInterviewModal from "@/app/admin/order/check-interview-modal";
	import OfferModal from "@/app/admin/order/offer-modal";
	import AddCommunicationModal from "@/app/admin/order/add-communication-modal";
	import ArrangeInterviewModal from "@/app/admin/order/arrange-interview-modal";
	import CommentModal from "@/app/admin/order/comment-modal";
	import ResumePreviewModal from "@/components/resume-preview-modal";
	import TimeBar from "@/components/time-bar.component";
	import ContractPassModal from "./contract-pass-modal";

	export default {
		name: "enterprisedetails",
		extends: baseComponentVue,
		components: {
			ContractPassModal,
			FailedModal,
			OrderDetail,
			CancelInterviewModal,
			CheckInterviewModal,
			OfferModal,
			AddCommunicationModal,
			ArrangeInterviewModal,
			CommentModal,
			ResumePreviewModal,
			TimeBar
		},
		data() {
			return {
				refusalMadel: false,
				refusalReasons: "",
				reasonsLength: "0",
				clean: false,
				communicate: {
					loading: false,
					visible: false,
					form: this.$form.createForm(this),
					key: '0'
				},
				baseUrl: process.env.VUE_APP_BASEURL,
				user_id: this.$route.query.user_id || getSearchString('user_id'),
				company: {},
				btn_state: [{
						name: "进行中",
						click: false,
						num: this.$store.getters.orderStatus("process").count
					},
					{
						name: "已完成",
						click: false,
						num: this.$store.getters.orderStatus("done").count
					},
					{
						name: "已关闭",
						click: false,
						num: this.$store.getters.orderStatus("closed").count
					},
				],
				order: 'process',
				btn_stage: [],
				options: [],
				suggestion: [],
				params: {
					timestring: [],
					name: "",
					statuses: "",
					time: [],
					city: [],
					company_name: "",
					main: "user_tel",
					jobType: "job_id",
					jobValue: "",
					mainValue: "",
					resume: "resume_mobile",
					resumeValue: "",
					ie_user_id: "",
				},
				pagination: {
					pageSize: 10,
					current: 1,
					total: 0,
					pageSizeOptions: ["10", "20", "50"],
					showTotal: (total) => `共 ${total} 条`,
					showQuickJumper: true,
					showSizeChanger: true,
				},
				pagination2: {
					pageSize: 10,
					current: 1,
					total: 0,
					pageSizeOptions: ["10", "20", "50"],
					showTotal: (total) => `共 ${total} 条`,
					showQuickJumper: true,
					showSizeChanger: true,
				},
				pagination3: {
					pageNo: 1,
					size: "small",
					pageSize: 10, // 默认每页显示数量
					showSizeChanger: true, // 显示可改变每页数量
					pageSizeOptions: ["10", "20", "50"], // 每页数量选项
					showTotal: total => `共 ${total} 条`, // 显示总数
					showQuickJumper: true,
					total: 0 //总条数
				},
				loading: false,
				loading2: false,
				loading3: false,
				drawer: false,
				order_id: undefined,
				dataSource: [],
				columns: [],
				dataSource2: [],
				columns2: [{
						title: '姓名',
						dataIndex: 'name',
						key: 'name',
						align: 'center'
					},
					{
						title: '手机号',
						dataIndex: 'tel',
						key: 'tel',
						align: 'center',
						width: 120
					},
					{
						title: '做单推荐',
						key: 'CREATED',
						scopedSlots: {
							customRender: 'CREATED'
						},
						align: 'center'
					},
					{
						title: '审核通过',
						key: 'AUDIT_PASSED',
						scopedSlots: {
							customRender: 'AUDIT_PASSED'
						},
						align: 'center'
					},
					{
						title: '面试',
						scopedSlots: {
							customRender: 'INTERVIEW'
						},
						key: 'INTERVIEW',
						align: 'center'
					},
					{
						title: 'Offer',
						scopedSlots: {
							customRender: 'OFFERED'
						},
						key: 'OFFERED',
						align: 'center'
					},
					{
						title: '入职',
						scopedSlots: {
							customRender: 'ENTERED'
						},
						key: 'ENTERED',
						align: 'center'
					},
					{
						title: '过保',
						scopedSlots: {
							customRender: 'COMPLETED'
						},
						key: 'COMPLETED',
						align: 'center'
					},
					{
						title: '已完成',
						scopedSlots: {
							customRender: 'complete'
						},
						key: 'complete',
						align: 'center'
					},
					{
						title: '已关闭',
						scopedSlots: {
							customRender: 'CLOSED'
						},
						key: 'CLOSED',
						align: 'center'
					},
					{
						title: '最近一次做单时间',
						scopedSlots: {
							customRender: 'newest_post'
						},
						key: 'newest_post',
						align: 'center'
					},
				],
				columns3: [{
						title: "合同信息",
						dataIndex: "info",
						key: "info",
						scopedSlots: {
							customRender: "info"
						}
					},
					{
						title: "签约信息",
						dataIndex: "signing_info",
						key: "signing_info",
						scopedSlots: {
							customRender: "signing_info"
						}
					},
					{
						title: "审核信息",
						dataIndex: "examine",
						key: "examine",
						scopedSlots: {
							customRender: "examine"
						}
					},
					{
						title: "合同附件",
						dataIndex: "enclosure",
						key: "enclosure",
						scopedSlots: {
							customRender: "enclosure"
						}
					},
					{
						title: "操作",
						key: "action",
						scopedSlots: {
							customRender: "action"
						}
					}
				],
				list: [],
				halfPage: false,
			}
		},
		computed: {
			...mapGetters(["isGranted"]),
			...mapState(['user'])
		},
		watch: {
			order() {
				console.log(this.btn_state)
				switch (this.order) {
					case 'process':
						this.btn_stage = this.btn_state[0].child
						break;
					case 'done':
						this.btn_stage = this.btn_state[1].child
						break;
					case 'closed':
						this.btn_stage = this.btn_state[2].child
						break;
					default:
						break;
				}
			}
		},
		created() {
			this.resetParams(1);
			this.setColums();
			this.getData2();
			this.user_id = this.$route.query.user_id;
			this.getData3();
		},
		async mounted() {
			try {
				let response = await Api.hunter.enterprisegetNewest({
					user_id: this.user_id
				});
				this.company = response.contract
			this.getHunterInfo();
				let num = await Api.hunter.enterpriseStatuses({
					owner_user_id: this.user_id
				});
				num.statuses.forEach((item, index) => {
					item.click = false;
					if (index == 0) {
						item.click = true;
					}
				})
				this.btn_state = num.statuses;
				this.btn_stage = this.btn_state[0].child
				this.btn_stage.forEach((item, index) => {
					item.click = false;
					if (index == 0) {
						item.click = true;
					}
				})
				this.params.statuses = this.btn_stage[0].value
				this.getData();
			} catch (e) {}
		},
		methods: {
			getHunterInfo() {
				Api.hunter.getHunterInfo({
					user_id: this.user_id
				}).then(res => {
					this.company.name = res.user.name;
					this.company.tel = res.user.tel;
				});
			},
			refuse(id) {
				this.refusalMadel = true;
				this.contractId = id;
			},
			handleRefusalLength(e) {
				this.reasonsLength = e.target.value.length;
			},
			handleRefuseCancel() {
				this.refusalMadel = false;
			},
			addRefuseModal() {
				let _this = this;
				if (this.refusalReasons) {
					let params = {
						contract_id: this.contractId,
						reject_reasons: this.refusalReasons
					};
					console.log(params);
					Api.hunter.rejectContract(params).then(() => {
						_this.refusalMadel = false;
						this.$message.info("审核不通过操作成功！");
						_this.getData();
					});
				} else {
					this.$message.info("请填写理由！");
				}
			},
			attachmentsDetail(url) {
				window.open(url, "_blank");
			},
			stopStep(text, record) {
				let {
					failedModal
				} = this.$refs;
				failedModal.title = text;
				failedModal.show(record);
			},
			nextStep(text, record) {
				console.log(text, record)
				const h = this.$createElement;
				this.$confirm({
					title: "温馨提示",
					content: h("div", {
						style: {
							paddingTop: "20px"
						}
					}, [
						h("p", `确定要将简历标记为"${text}"`),
						h("p", "该操作不可逆，请谨慎操作"),
					]),
					onOk: () => {
						//受理推荐
						if (record.status === "DELIVER") {
							return new Promise(async (resolve, reject) => {
								try {
									await Api.order.deliveryAudit({
										post_id: record.id
									});
									this.getData();
								} catch (e) {}
								resolve();
							});
						}
						//审核通过
						if (record.status === "CREATED") {
							return new Promise(async (resolve, reject) => {
								try {
									await Api.order.audit({
										post_id: record.id
									});
									this.getData();
								} catch (e) {}
								resolve();
							});
						}
						//推荐通过
						if (record.status === "AUDIT_PASSED") {
							return new Promise(async (resolve, reject) => {
								try {
									await Api.order.submit({
										post_id: record.id
									});
									this.getData();
								} catch (e) {}
								resolve();
							});
						}
						//入职
						if (record.status === "OFFERED") {
							return new Promise(async (resolve, reject) => {
								try {
									await Api.order.entered({
										post_id: record.id
									});
									this.getData();
								} catch (e) {}
								resolve();
							});
						}
						//过保
						if (record.status === "ENTERED") {
							return new Promise(async (resolve, reject) => {
								try {
									await Api.order.completed({
										post_id: record.id
									});
									this.getData();
								} catch (e) {}
								resolve();
							});
						}
						//归档
						if (record.status === "COMPLETED") {
							return new Promise(async (resolve, reject) => {
								try {
									await Api.order.done({
										post_id: record.id
									});
									this.getData();
								} catch (e) {}
								resolve();
							});
						}
					},
				});
			},
			async getData3(pagination) {
				this.loading3 = true;
				if (pagination) {
					let pager = {
						...this.pagination
					};
					pager.current = pagination.current;
					this.pagination3 = pager;
				} else {
					this.pagination3.current = 1;
				}
				let params = {
					user_id: this.user_id,
					page: this.pagination3.current,
					limit: this.pagination3.pageSize
				};
				let response = await Api.hunter.getContractList(params);
				this.loading3 = false;
				this.pagination3.total = +response.total;
				this.list = response.list;
				console.log(response);
			},
			handleOk() {

			},
			// 标记面试未通过
			unpassInterview(record) {
				let {
					failedModal
				} = this.$refs;
				failedModal.title = "面试未通过";
				failedModal.show(record);
			},
			viewDetail(record) {
				this.drawer = false;
				let resolveDRoute = this.$router.resolve({
					path: `/order/detail/${this.order_id}`,
				});
				window.open(resolveDRoute.href, "_blank");
			},
			setColums() {
				this.order == "process" ?
					this.setActionColums() :
					this.setNoActionColums();
			},
			setActionColums() {
				let columns = [
					// {
					// 	title: "做单号",
					// 	dataIndex: "id",
					// },
					{
						title: "订单号",
						dataIndex: "order_no",
					},
					{
						title: "职位",
						dataIndex: "job_name",
					},
					{
						title: "候选人",
						dataIndex: "resume_name",
					},
					{
						title: "猎头",
						dataIndex: "hunter_name",
						scopedSlots: {
							customRender: "hunter"
						},
					},
					{
						width: "200px",
						align: "center",
						title: "订单阶段",
						dataIndex: "status",
						scopedSlots: {
							customRender: "status"
						},
					},
					{
						title: "订单状态",
						dataIndex: "status_text",
					},
					{
						title: "更新时间",
						dataIndex: "updated_at",
					},
				];
				if (this.isGranted("post_manager.post_process_list.btn_list_audit")) {
					columns.push({
						align: "center",
						title: "操作",
						key: "action",
						scopedSlots: {
							customRender: "action"
						},
					});
				}
				this.columns = columns;
			},
			setNoActionColums() {
				this.columns = [
					// {
					// 	title: "做单号",
					// 	dataIndex: "id",
					// },
					{
						title: "订单号",
						dataIndex: "order_no",
					},
					{
						title: "职位",
						dataIndex: "job_name",
					},
					{
						title: "候选人",
						dataIndex: "resume_name",
					},
					{
						title: "猎头",
						dataIndex: "hunter_name",
						scopedSlots: {
							customRender: "hunter"
						},
					},
					{
						width: "200px",
						align: "center",
						title: "订单阶段",
						dataIndex: "status",
						scopedSlots: {
							customRender: "status"
						},
					},
					{
						title: "订单状态",
						dataIndex: "status_text",
					},
					{
						title: "更新时间",
						dataIndex: "updated_at",
					},
				];
			},
			rowClick(record) {
				return {
					on: {
						click: () => {
							this.drawer = true;
							this.order_id = record.id;
							this.communicate.key = '0';
						},
					},
				};
			},
			//IE 搜索建议
			async handleSearch(value) {
				if (!value) return;
				let response = await Api.account.suggest({
					name: value
				});
				let arr = [];
				response.forEach((item) => {
					arr.push({
						value: item.uid,
						text: item.name
					});
				});
				this.suggestion = arr;
			},
			resetParams(idx) {
				if (idx == 1) {
					let params = {
						time: [],
						city: [],
						company_name: "",
						main: "user_tel",
						jobType: "job_id",
						jobValue: "",
						mainValue: "",
						resume: "resume_mobile",
						resumeValue: "",
						ie_user_id: "",
					};
					this.params = {
						statuses: this.params.statuses,
						...params
					};
				} else {
					this.params.name = null;
					this.params.timestring = [];
					this.clean = true;
				}
			},
			getFilterData(idx) {
				if (idx == 1) {
					this.pagination.current = 1;
					this.getData();
				} else {
					this.getData2();
				}
			},
			async getData(pagination, filters, sorter) {
				getOrderStatus();
				this.loading = true;
				if (pagination) {
					let pager = {
						...this.pagination
					};
					pager.current = pagination.current;
					pager.pageSize = pagination.pageSize;
					this.pagination = pager;
				}
				let params = {
					show: 1,
					is_company_job: 1,
					owner_user_id: this.user_id,
					statuses: this.params.statuses,
					created_start: this.params.time[0] && this.params.time[0].format("YYYY-MM-DD"),
					created_end: this.params.time[1] && this.params.time[1].format("YYYY-MM-DD"),
					province_id: this.params.city[0],
					city_id: this.params.city[1],
					dist_id: this.params.city[2],
					company_name: this.params.company_name,
					[this.params.main]: this.params.mainValue,
					[this.params.resume]: this.params.resumeValue,
					[this.params.jobType]: this.params.jobValue,
					order_no: this.params.order_no,
					ie_user_id: this.params.ie_user_id,
					page: this.pagination.current,
					limit: this.pagination.pageSize,
				};
				try {
					let response = await Api.order.getList(params);
					this.pagination.total = +response.total;
					this.dataSource = response.list;
				} catch (e) {}
				this.loading = false;
			},
			async getData2(pagination, filters, sorter) {
				this.loading2 = true;
				if (pagination) {
					let pager = {
						...this.pagination2
					};
					pager.current = pagination.current;
					pager.pageSize = pagination.pageSize;
					this.pagination2 = pager;
				}
				let params = {
					time_start: this.params.timestring ? this.params.timestring[0] : null,
					time_end: this.params.timestring ? this.params.timestring[1] : null,
					name: this.params.name,
					owner_user_id: this.user_id,
					page: this.pagination2.current,
					limit: this.pagination2.pageSize,
				};
				try {
					let response = await Api.hunter.enterpriseHunter(params);
					this.pagination2.total = +response.total;
					this.dataSource2 = response.list;
				} catch (e) {}
				this.loading2 = false;
			},
			onChangetime(a) {
				console.log(a)
				this.params.timestring = a.value
				this.getData2();
			},
			async getOptions() {
				this.options = undefined;
				let {
					tree
				} = await Api.common.getCityTree();
				this.options = tree;
			},
			get_stage(index, key) {
				let a = JSON.parse(JSON.stringify(this.btn_stage));
				for (let i = 0; i < a.length; i++) {
					a[i].click = false;
					if (index == i) {
						a[i].click = true;
					}
				}
				this.btn_stage = a;
				this.params.statuses = key
				this.getData();
			},
			get_state(index) {
				switch (index) {
					case 0:
						this.order = 'process';
						break;
					case 1:
						this.order = 'done';
						break;
					case 2:
						this.order = 'closed';
						break;
				}
				for (let i = 0; i < this.btn_state.length; i++) {
					this.btn_state[i].click = false;
					if (index == i) {
						this.btn_state[i].click = true;
					}
				}
			},
			async callback(key) {
				if (key == 2) {
					try {
						let response = await Api.order.getList({
							owner_user_id: this.user_id,
							is_company_job: 1
						});
						console.log(response)
					} catch (e) {}
				}
			},
		}
	}
</script>

<style lang="scss">
	.Newest_title {
		font-size: 18px;
		font-weight: bold;
	}

	.order-page {
		.ant-table-row {
			cursor: pointer;
		}
	}

	.tag {
		border: 1px solid #00a2eb;
		padding: 2px 3px;

		&.blue {
			color: #fff;
			background: #00a2eb;
		}

		&:not(:first-child) {
			border-left: none;
		}
	}

	.badge {
		position: relative;
		display: inline-block;
		color: #fff;
		background: rgb(224, 9, 9);
		font-size: 12px;
		padding: 0 2px;
		border-radius: 2px;
		top: -8px;
		left: 2px;
	}

	.half-page {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 1000;

		.content-box {
			position: absolute;
			top: 0;
			right: 0;
			width: 1600px;
			height: 100%;
			overflow: auto;
			background: #fff;
			box-shadow: 0px 0px 44px 0px rgba(0, 0, 0, 0.16);
			padding: 30px 40px;

			.close {
				cursor: pointer;
			}

			.new_win {
				cursor: pointer;
				color: #999;
				display: flex;
				align-items: center;

				.anticon {
					font-size: 16px;
					margin-right: 6px;
				}
			}
		}
	}
</style>
